import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'

const base = 'settings'

AdminRouter.addRoutes([
  {
    path: `/${base}`,
    name: `${base}`,
    component: () => import('./UserForm.vue'),
    meta: {
      auth: true,
    },
  },
])

AdminSidebar.pushItem({
  id: `${base}`,
  order: 10,
  header: $vm => $vm.$t(`general.menu_settings`),
  text: $vm => $vm.$t('general.menu_settings'),
  route: {
    name: `${base}`,
  },
  icon: 'icon-gear',
  permission: () => true,
})
